import React, { useEffect, createElement } from 'react';
import { Check, X, Calendar, Monitor, DollarSign, User, ArrowRight } from 'lucide-react';
export function LandingPage() {
  useEffect(() => {
    // Load Wistia player script
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.body.appendChild(script1);
    // Load Wistia embed script
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/rkj8snygct.js';
    script2.async = true;
    script2.type = 'module';
    document.body.appendChild(script2);
    // Add Wistia styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='rkj8snygct']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/rkj8snygct/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top: 216.11%; 
      }
    `;
    document.head.appendChild(style);
    // Meta Pixel Code
    const metaPixelScript = document.createElement('script');
    metaPixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '728846210293765');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(metaPixelScript);
    return () => {
      // Cleanup
      document.body.removeChild(script1);
      document.body.removeChild(script2);
      document.head.removeChild(style);
      document.head.removeChild(metaPixelScript);
    };
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-orange-100 selection:text-orange-900" data-id="element-1">
      {/* Hero Section */}
      <header className="bg-white text-slate-900 pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3">
          <div className="inline-flex items-center gap-2 bg-orange-500/10 text-orange-600 px-3 py-1 rounded-full text-sm font-medium mb-6 border border-orange-500/20" data-id="element-4">
            <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" data-id="element-5"></span>
            Entrenamiento Online en Vivo
          </div>

          <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768615618/Hook_Pagina_de_ventas_Juega_desde_Otro_Nivel_mptj6p.jpg" alt="Juega desde Otro Nivel" className="w-full max-w-2xl mx-auto mb-8 rounded-2xl shadow-2xl" data-id="element-6" />

          <div className="flex flex-wrap justify-center gap-4 text-slate-600 mb-8 text-sm sm:text-base" data-id="element-7">
            <div className="flex items-center gap-2" data-id="element-8">
              <User className="w-4 h-4 text-orange-500" data-id="element-9" />
              <span data-id="element-10">Para líderes y vendedores de alto rendimiento</span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto mb-12 bg-slate-50 p-4 rounded-2xl border border-slate-200" data-id="element-11">
            <div className="flex items-center justify-center gap-2" data-id="element-12">
              <Calendar className="w-5 h-5 text-orange-500" data-id="element-13" />
              <span className="font-medium text-slate-900" data-id="element-14">
                Martes 27 de enero
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 border-y sm:border-y-0 sm:border-x border-slate-200 py-2 sm:py-0" data-id="element-15">
              <Monitor className="w-5 h-5 text-orange-500" data-id="element-16" />
              <span className="font-medium text-slate-900" data-id="element-17">
                Online · En Vivo
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-18">
              <DollarSign className="w-5 h-5 text-orange-500" data-id="element-19" />
              <span className="font-medium text-slate-900" data-id="element-20">$15</span>
            </div>
          </div>

          <div className="space-y-4" data-id="element-21">
            <h2 className="text-2xl sm:text-3xl font-semibold text-slate-900" data-id="element-22">
              Diseña tu 2026 sin agotarte
            </h2>
            <p className="text-lg text-slate-700 max-w-2xl mx-auto" data-id="element-23">
              👉 Esto no es motivación.
              <br data-id="element-24" />
              Es estructura para dejar de sostenerlo todo solo.
            </p>
          </div>

          <div className="mt-10" data-id="element-25">
            <a href="https://coneckta.co/taller-juegadesdeotronivel" target="_blank" rel="noopener noreferrer" className="bg-orange-500 hover:bg-orange-400 text-white font-bold py-4 px-8 rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-orange-500/20 flex items-center gap-2 mx-auto w-fit" data-id="element-26">
              Entrar al entrenamiento
              <ArrowRight className="w-5 h-5" data-id="element-27" />
            </a>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-28">
        <div className="prose prose-lg prose-slate mx-auto" data-id="element-29">
          <p className="text-xl font-medium text-slate-700 leading-relaxed" data-id="element-30">
            Arrancaste el año en acción.
            <br data-id="element-31" />
            Agenda llena.
            <br data-id="element-32" />
            Equipo activo.
            <br data-id="element-33" />
            Objetivo claro: facturar.
          </p>

          <div className="my-8 p-6 bg-white border-l-4 border-orange-500 shadow-sm rounded-r-lg" data-id="element-34">
            <p className="font-bold text-slate-900 italic mb-4" data-id="element-35">
              Pero seamos honestos:
            </p>
            <p className="text-slate-700" data-id="element-36">
              Si hoy alguien te preguntara
              <br data-id="element-37" />
              <span className="font-semibold text-slate-900" data-id="element-38">
                "¿Cuál es el plan real para 2026?"
              </span>
              <br data-id="element-39" />
              ¿Responderías con claridad…
              <br data-id="element-40" />o con puro entusiasmo?
            </p>
          </div>

          <p className="text-lg font-medium text-slate-900 mb-8" data-id="element-41">
            👉 Accionar sin estructura no es liderazgo.
            <br data-id="element-42" />
            Es desgaste bien organizado.
          </p>

          <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768604834/Testimonio_1_Claridad_juega_desde_otro_nivel_z0bcbl.jpg" alt="Testimonio" className="w-full max-w-2xl mx-auto rounded-xl shadow-lg" data-id="element-43" />
        </div>
      </section>

      {/* Solution Concept */}
      <section className="py-12 bg-white border-y border-slate-200" data-id="element-44">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-45">
          <h2 className="text-3xl font-bold text-slate-900 mb-8" data-id="element-46">
            El problema no es que hagas poco
            <br data-id="element-47" />
            <span className="text-orange-600" data-id="element-48">
              Es que sigues jugando sin sistema
            </span>
          </h2>

          <p className="text-lg text-slate-600 mb-8" data-id="element-49">
            El crecimiento sostenible no se construye con fuerza.
            <br data-id="element-50" />
            Se construye con:
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-51">
            {['Claridad', 'Foco real', 'Sistemas simples'].map(item => <span key={item} className="flex items-center gap-2 bg-slate-100 px-4 py-2 rounded-lg font-medium text-slate-800" data-id="element-52">
                <Check className="w-5 h-5 text-orange-600" data-id="element-53" />
                {item}
              </span>)}
          </div>

          <p className="text-xl font-medium text-slate-900 mb-16" data-id="element-54">
            Y cuando lideras equipos, esto pesa el doble.
            <br data-id="element-55" />
            <span className="text-orange-600" data-id="element-56">
              👉 Tu forma de jugar se replica.
            </span>
          </p>

          <div className="bg-slate-900 text-white p-8 rounded-2xl shadow-xl max-w-3xl mx-auto text-left" data-id="element-57">
            <h3 className="text-2xl font-bold mb-4 text-orange-400" data-id="element-58">
              ¿Qué es Juega desde Otro Nivel?
            </h3>
            <p className="text-lg text-slate-300 mb-6" data-id="element-59">
              Un entrenamiento online, práctico y confrontativo.
            </p>
            <div className="space-y-4 border-l-2 border-orange-500/30 pl-6" data-id="element-60">
              <p data-id="element-61">No vienes a inspirarte.</p>
              <p data-id="element-62">
                Vienes a cerrar decisiones, eliminar fricción y rediseñar cómo
                estás jugando.
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-700" data-id="element-63">
              <p className="font-bold text-lg mb-8" data-id="element-64">
                👉 Aquí no aprendes a hacer más.
                <br data-id="element-65" />
                <span className="text-orange-400" data-id="element-66">Aprendes a jugar mejor.</span>
              </p>

              <div className="rounded-xl overflow-hidden shadow-2xl" data-id="element-67">
                <wistia-player media-id="rkj8snygct" aspect="0.46272493573264784" data-id="element-68"></wistia-player>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Curriculum / What You'll Work On */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-69"></section>

      {/* Benefits */}
      <section className="py-20 bg-slate-900 text-white" data-id="element-70">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-72">
            <div data-id="element-73">
              <h2 className="text-3xl font-bold mb-8" data-id="element-74">Lo que te llevas</h2>
              <ul className="space-y-4" data-id="element-75">
                {['Menos cansancio mental', 'Más dirección diaria', 'Decisiones claras', 'Avance sostenible', 'Liderazgo sin desgaste'].map((benefit, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-76">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center" data-id="element-77">
                      <Check className="w-4 h-4 text-white" data-id="element-78" />
                    </div>
                    <span className="text-lg text-slate-200" data-id="element-79">{benefit}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-80">
              <p className="text-xl font-medium mb-6 text-slate-300" data-id="element-81">
                No se trata de hacer más
                <br data-id="element-82" />
                Se trata de dejar de correr sin dirección
              </p>
              <p className="text-2xl font-bold text-white mb-8" data-id="element-83">
                Y eso es lo que vas a aprender aquí.
              </p>

              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768612492/Testimonio_2_escrito_Monica_Diaz_Online_w2sbhz.jpg" alt="Testimonio Monica Diaz" className="w-full rounded-xl shadow-lg" data-id="element-84" />
            </div>
          </div>
        </div>
      </section>

      {/* Before / After */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-85">
        <div className="max-w-4xl mx-auto" data-id="element-86">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-87">
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-88">
              <h3 className="text-xl font-bold text-slate-500 mb-6 uppercase tracking-wider" data-id="element-89">
                ANTES
              </h3>
              <ul className="space-y-4" data-id="element-90">
                <li className="flex items-start gap-3 text-slate-600" data-id="element-91">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-92" />
                  Mucha acción, poca claridad
                </li>
                <li className="flex items-start gap-3 text-slate-600" data-id="element-93">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-94" />
                  Resultados que dependen de ti
                </li>
                <li className="flex items-start gap-3 text-slate-600" data-id="element-95">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-96" />
                  Equipo activo, pero dependiente
                </li>
              </ul>
            </div>

            <div className="bg-orange-50 p-8 rounded-2xl border border-orange-100 relative overflow-hidden" data-id="element-97">
              <div className="absolute top-0 right-0 w-20 h-20 bg-orange-100 rounded-bl-full -mr-10 -mt-10" data-id="element-98"></div>
              <h3 className="text-xl font-bold text-orange-700 mb-6 uppercase tracking-wider relative z-10" data-id="element-99">
                DESPUÉS
              </h3>
              <ul className="space-y-4 relative z-10" data-id="element-100">
                <li className="flex items-start gap-3 text-slate-800 font-medium" data-id="element-101">
                  <Check className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" data-id="element-102" />
                  Dirección clara
                </li>
                <li className="flex items-start gap-3 text-slate-800 font-medium" data-id="element-103">
                  <Check className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" data-id="element-104" />
                  Decisiones con foco
                </li>
                <li className="flex items-start gap-3 text-slate-800 font-medium" data-id="element-105">
                  <Check className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" data-id="element-106" />
                  Avance sostenible
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 max-w-2xl mx-auto" data-id="element-107">
            <div className="rounded-xl overflow-hidden shadow-2xl" data-id="element-108">
              <wistia-player media-id="zadn492ltd" aspect="0.5164992826398852" data-id="element-109"></wistia-player>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-110">
        <div className="max-w-3xl mx-auto" data-id="element-111">
          <div className="mb-16" data-id="element-112">
            <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-113">
              Este entrenamiento es para ti si:
            </h3>
            <div className="grid gap-4" data-id="element-114">
              {['Lideras equipos', 'Eres vendedor/a de alto desempeño', 'Ya tienes resultados', 'Sabes que seguir así no es sostenible', 'Quieres diseñar, no improvisar, tu 2026'].map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm border border-slate-100" data-id="element-115">
                  <Check className="w-5 h-5 text-orange-500" data-id="element-116" />
                  <span className="text-slate-800" data-id="element-117">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-slate-200 h-px w-full my-12" data-id="element-118"></div>

          <div data-id="element-119">
            <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-120">
              Esto NO es
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-121">
              <div className="space-y-3" data-id="element-122">
                {['Motivación vacía', 'Productividad genérica', 'Más presión'].map((item, idx) => <div key={idx} className="flex items-center gap-3 text-slate-500" data-id="element-123">
                    <X className="w-5 h-5 text-slate-400" data-id="element-124" />
                    <span data-id="element-125">{item}</span>
                  </div>)}
              </div>
              <div className="space-y-3" data-id="element-126">
                {['Es claridad', 'Es estructura', 'Es decidir mejor'].map((item, idx) => <div key={idx} className="flex items-center gap-3 text-slate-900 font-medium" data-id="element-127">
                      <Check className="w-5 h-5 text-orange-600" data-id="element-128" />
                      <span data-id="element-129">{item}</span>
                    </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Details & CTA */}
      <section className="py-20 bg-slate-900 text-white text-center px-4" data-id="element-130">
        <div className="max-w-3xl mx-auto" data-id="element-131">
          <h2 className="text-3xl font-bold mb-12" data-id="element-132">Detalles</h2>

          <div className="flex flex-col sm:flex-row justify-center gap-6 mb-12 text-lg" data-id="element-133">
            <div className="flex items-center justify-center gap-2 bg-slate-800 px-6 py-3 rounded-xl" data-id="element-134">
              <Calendar className="w-5 h-5 text-orange-400" data-id="element-135" />
              <span data-id="element-136">Martes 27 de enero</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-800 px-6 py-3 rounded-xl" data-id="element-137">
              <Monitor className="w-5 h-5 text-orange-400" data-id="element-138" />
              <span data-id="element-139">Online · En Vivo</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-800 px-6 py-3 rounded-xl" data-id="element-140">
              <DollarSign className="w-5 h-5 text-orange-400" data-id="element-141" />
              <span data-id="element-142">$15</span>
            </div>
          </div>

          <div className="space-y-2 mb-12 text-slate-300" data-id="element-143">
            <p data-id="element-144">👉 No es para motivarte.</p>
            <p className="text-white font-medium" data-id="element-145">
              👉 Es para ordenar tu forma de jugar.
            </p>
          </div>

          <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768613912/Testimonio_escrito_Diana_3_e5hk7d.jpg" alt="Testimonio Diana" className="w-full max-w-2xl mx-auto rounded-xl shadow-lg mb-12" data-id="element-146" />

          <div className="bg-orange-600/10 border border-orange-500/30 p-8 rounded-2xl mb-12" data-id="element-147">
            <p className="text-xl font-medium mb-8" data-id="element-148">
              Estoy listo para jugar desde otro nivel
            </p>
            <a href="https://coneckta.co/taller-juegadesdeotronivel" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-orange-500 hover:bg-orange-400 text-white font-bold py-4 px-12 rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-orange-500/20 flex items-center justify-center gap-2 mx-auto" data-id="element-149">
              👉 Entrar al entrenamiento
            </a>
          </div>

          <p className="text-xl italic text-slate-400 max-w-2xl mx-auto" data-id="element-150">
            "Jugar desde otro nivel no es trabajar más.
            <br data-id="element-151" />
            Es avanzar con inteligencia, claridad y sistemas."
          </p>
        </div>
      </section>

      {/* Mentors */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-152">
        <div className="max-w-4xl mx-auto" data-id="element-153">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-154">
            <div className="order-2 md:order-1" data-id="element-155">
              <h2 className="text-sm font-bold text-orange-600 tracking-widest uppercase mb-2" data-id="element-156">
                Mentores
              </h2>

              <h3 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-157">
                Blas Miliani & Carolina Gómez
              </h3>
              <div className="space-y-4 text-slate-600 mb-8" data-id="element-158">
                <p data-id="element-159">Ingenieros de formación.</p>
                <p data-id="element-160">Estrategas por experiencia.</p>
                <p data-id="element-161">Líderes por resultados.</p>
              </div>

              <ul className="space-y-3 mb-8" data-id="element-162">
                {['+20 años en ventas reales', 'Venta directa y liderazgo de equipos', 'Entrenamientos en más de 5 países'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-slate-800 font-medium" data-id="element-163">
                    <Check className="w-5 h-5 text-orange-500" data-id="element-164" />
                    {item}
                  </li>)}
              </ul>

              <div className="p-4 bg-slate-50 border-l-4 border-slate-900" data-id="element-165">
                <p className="font-medium text-slate-900" data-id="element-166">
                  No crecimos leyendo teoría.
                  <br data-id="element-167" />
                  Crecimos ejecutando.
                </p>
              </div>
            </div>
            <div className="order-1 md:order-2 rounded-2xl overflow-hidden shadow-lg" data-id="element-168">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768059311/Foto_mentores_u6buos.png" alt="Blas Miliani & Carolina Gómez" className="w-full h-full object-cover" data-id="element-169" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission / Footer */}
      <footer className="bg-slate-50 py-20 px-4 sm:px-6 lg:px-8 border-t border-slate-200" data-id="element-170">
        <div className="max-w-3xl mx-auto text-center" data-id="element-171">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-172">
            Nuestra misión
          </h2>
          <p className="text-lg text-slate-600 mb-8" data-id="element-173">
            Ayudar a profesionales de alto rendimiento a:
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-12" data-id="element-174">
            {['Crecer sin quemarse', 'Liderar sin cargarlo todo', 'Liberar tiempo real'].map((item, idx) => <div key={idx} className="flex items-center justify-center gap-2 font-medium text-slate-800" data-id="element-175">
                <Check className="w-5 h-5 text-orange-500" data-id="element-176" />
                {item}
              </div>)}
          </div>

          <div className="text-slate-400 text-sm" data-id="element-177">
            © 2026 Juega desde Otro Nivel
          </div>
        </div>
      </footer>
    </div>;
}